enum Mints {
  USDC = 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
  USDT = 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
  SOL = 'FAKE_SOL_MINT' // TODO: change on prod
}

export const mints = {
  [Mints.USDT]: 'USDT',
  [Mints.USDC]: 'USDC',
  [Mints.SOL]: 'SOL',
}

export const symbolToMintMap = {
  [Mints.USDT]: Mints.USDT,
  [Mints.USDC]: Mints.USDC,
  [Mints.SOL]: Mints.SOL,
}
